import user from "./models/user";
import customer from "./models/customer";
import colorVariant from "./models/colorVariant";
import sizeVariant from "./models/sizeVariant";
import productVariant from "./models/productVariant";
import product from "./models/product";
import supplier from "./models/supplier";
import rajaOngkir from "./models/rajaOngkir";
import category from "./models/category";
import salesOrder from "./models/salesOrder";
import salesOrderEditRequest from "./models/salesOrderEditRequest";
import address from "./models/address";
import invoice from "./models/invoice";
import payment from "./models/payment";
import report from "./models/report";
import purchaseOrder from "./models/purchaseOrder";
import deliveryOrder from "./models/deliveryOrder";
import receiveOrder from "./models/receiveOrder";
import purchaseOrderItem from "./models/purchaseOrderItem";
import receiveOrderItem from "./models/receiveOrderItem";
import uploadImage from "./models/upload";
import credit from "./models/credit";
import requestApprove from "./models/requestApprove";
import orderItem from "./models/orderItem";
import state from "./models/state";
import subdistrict from "./models/subdistrict";
import city from "./models/city";
import district from "./models/district";
import productCode from "./models/productCode";
import salesChannel from "./models/salesChannel";
import stockOpname from "./models/stockOpname";
import scrap from "./models/scrap";
import returSupplier from "./models/returSupplier";
import returCustomer from "./models/returCustomer";
import stockMovement from "./models/stockMovement";
import warehouseTransfer from "./models/warehouseTransfer";
import warehouse from "./models/warehouse";
import storeReport from "./models/storeReport";

export default {
  user,
  customer,
  category,
  colorVariant,
  sizeVariant,
  productVariant,
  product,
  productCode,
  supplier,
  returSupplier,
  rajaOngkir,
  state,
  salesOrder,
  salesChannel,
  salesOrderEditRequest,
  requestApprove,
  address,
  invoice,
  payment,
  report,
  purchaseOrder,
  deliveryOrder,
  receiveOrder,
  purchaseOrderItem,
  receiveOrderItem,
  uploadImage,
  credit,
  orderItem,
  subdistrict,
  city,
  district,
  stockOpname,
  scrap,
  returCustomer,
  stockMovement,
  warehouseTransfer,
  warehouse,
  storeReport,
};

export {
  user,
  customer,
  category,
  colorVariant,
  sizeVariant,
  productVariant,
  product,
  productCode,
  supplier,
  returSupplier,
  rajaOngkir,
  state,
  salesOrder,
  salesChannel,
  salesOrderEditRequest,
  requestApprove,
  address,
  invoice,
  payment,
  report,
  purchaseOrder,
  deliveryOrder,
  receiveOrder,
  purchaseOrderItem,
  receiveOrderItem,
  uploadImage,
  credit,
  orderItem,
  subdistrict,
  city,
  district,
  stockOpname,
  scrap,
  returCustomer,
  stockMovement,
  warehouseTransfer,
  warehouse,
  storeReport,
};
